<template>
    <div class="channel-list-body">
        <div class="channel-title">
            地上・BS・CS放送48局
        </div>
        <div class="channel-btn-area">
            <div class="channel-btn" 
                v-for="(n, index) in channelData" 
                :key="index" 
                @click="selectedIndex = index" 
                :class="{selected: selectedIndex === index}">
                {{ n.name }} <span>{{ n.num }}ch</span>
            </div>
        </div>
        <div class="channel-list">
            <div class="channel" 
                v-for='(n, index) in channelData[selectedIndex].data' 
                :key="index">
                {{ n }}
            </div>
        </div>
    </div>
</template>
<script>
import channelData from '../../../js/channel-data'
export default {
    data () {
        return {
            channelData,
            selectedIndex: 0
        }
    },
    methods: {
        setIndex (index) {
            this.selectedIndex = index
        }
    }
}
</script>
<style scoped>
.channel-list-body {
    background: #000;
    color: #fff;
    text-align: center;
    padding-top: 40px;
    padding-bottom: 40px;
    background-image: url(../../../images/channel-bg.png);
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: 0;
}
.channel-title {
    font-size: 24px;
    font-family: A-OTF Gothic MB101 Pr5;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 43px;
    margin-bottom:20px;
    position: relative;
}
.channel-btn-area {
    display: flex;
    width: 80%;
    margin: 0 auto;
    justify-content: space-between;
}
.channel-btn {
    padding: 10px 15px;
    font-size: 20px;
    font-weight: bold;
    vertical-align: top;
    line-height: 20px;
    position: relative;
    transition: all .2s;
    margin-bottom: 20px;
    background: #1A1303;
}
.channel-btn span {
    font-size: 12px;
}
.channel-btn::before {
    content: '';
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 0;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin: auto;
    transition: all .2s;
}
.channel-btn.selected {
    background: #FDB819;
    color: #fff;
}
.channel-btn.selected::before {
    content: '';
    width: 0;
    height: 0;
    border-top: 10px solid #FDB819;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 0;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin: auto;
}
.channel-list {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    text-align: left;
}
.channel {
    width: 50%;
    text-align: left;
    display: inline-block;
    box-sizing: border-box;
    padding: 5px;
    vertical-align: top;
    font-size: 12px;
}
</style>